import { formatInTimeZone, zonedTimeToUtc } from 'date-fns-tz';

export const SCHEDULE_TIME_ZONE = 'America/Sao_Paulo';

export const scheduleMinimum = (now = new Date()) =>
  formatInTimeZone(now, SCHEDULE_TIME_ZONE, "yyyy-MM-dd'T'HH:mm");

export const scheduleToUtc = value =>
  value ? zonedTimeToUtc(value, SCHEDULE_TIME_ZONE).toISOString() : '';
